import { render } from "./ArticleSearch.vue?vue&type=template&id=c5b1ea60&scoped=true"
import script from "./ArticleSearch.vue?vue&type=script&lang=js"
export * from "./ArticleSearch.vue?vue&type=script&lang=js"

import "./ArticleSearch.vue?vue&type=style&index=0&id=c5b1ea60&lang=less&scoped=true"

import exportComponent from "G:\\小程序\\OT ASAR\\vue后台\\vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c5b1ea60"]])

export default __exports__